import { render, staticRenderFns } from "./Client_chat.vue?vue&type=template&id=3b1ac032&scoped=true"
import script from "./Client_chat.vue?vue&type=script&lang=js"
export * from "./Client_chat.vue?vue&type=script&lang=js"
import style0 from "./Client_chat.vue?vue&type=style&index=0&id=3b1ac032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ac032",
  null
  
)

export default component.exports